import React from "react";
import { OnboardingTask, OnboardingTaskStatus } from "../types";
import { OnboardingSubtaskItem } from "./OnboardingSubtaskItem";

interface OnboardingTaskItemProps {
  task: OnboardingTask;
  isCompleted?: boolean;
  onToggleStatus: (
    taskId: string,
    currentStatus: OnboardingTaskStatus,
  ) => Promise<void>;
  onToggleSubtask: (taskId: string, subtaskId: string) => Promise<void>;
}

export const OnboardingTaskItem: React.FC<OnboardingTaskItemProps> = ({
  task,
  isCompleted = false,
  onToggleStatus,
  onToggleSubtask,
}) => {
  const completedCount = task.subtasks.filter((s) => s.completed).length;
  const totalCount = task.subtasks.length;
  const progressPercent =
    totalCount > 0 ? (completedCount / totalCount) * 100 : 0;

  return (
    <div className="bg-white dark:bg-gray-800 shadow-sm rounded-xl p-4">
      <div className="space-y-3">
        <div className={isCompleted ? "opacity-60" : ""}>
          <div className="flex items-center justify-between">
            <label className="flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={task.status === OnboardingTaskStatus.COMPLETED}
                onChange={() => onToggleStatus(task.id, task.status)}
                className="form-checkbox w-5 h-5 rounded-full peer cursor-pointer"
              />
              <span className="font-medium text-gray-800 dark:text-gray-100 peer-checked:line-through ml-2">
                {task.title}
              </span>
            </label>
            <span className="text-sm text-gray-500 dark:text-gray-400">
              {completedCount}/{totalCount}
            </span>
          </div>

          <div className="mt-2 h-1.5 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
            <div
              className="h-full bg-blue-500 transition-all duration-300"
              style={{ width: `${progressPercent}%` }}
            />
          </div>
        </div>

        {task.subtasks.length > 0 && (
          <ul className="pl-7 space-y-1">
            {task.subtasks.map((subtask) => (
              <li key={subtask.id}>
                <OnboardingSubtaskItem
                  taskId={task.id}
                  subtask={subtask}
                  onToggle={onToggleSubtask}
                  isCompleted={subtask.completed}
                />
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};
